import { render, staticRenderFns } from "./Teamship.vue?vue&type=template&id=188e1508&scoped=true"
import script from "./Teamship.vue?vue&type=script&lang=ts"
export * from "./Teamship.vue?vue&type=script&lang=ts"
import style0 from "./Teamship.vue?vue&type=style&index=0&id=188e1508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e1508",
  null
  
)

export default component.exports